<template>
  <button
    type="button"
    v-on:click="click"
    :class="[
      'ui button',
      customClass,
      colorClass,
      position,
      { 'icon': classIcon },
      { 'labeled ': title != '' },
      { disabled: disabled },
      { loading: loading },
    ]"
  >
    <i v-if="classIcon" :class="classIcon"></i>
    {{ title }}
  </button>
</template>

<script>

export default {
  name: 'Button',
  props: {
    buttonColor: {
      type: [String, Array],
      default: 'green',
    },
    classIcon: {
      type: [String, Array],
      default: '',
    },
    title: {
      type: String,
    },
    position: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: true,
    },
    classButton: {
      type: String,
      default: 'compact small',
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      customClass: this.classButton,
    };
  },
  computed: {
    colorClass() {
      return this.buttonColor ? this.buttonColor : 'green';
    },
  },
  methods: {
    click() {
      this.$emit('click');
    },
  },
};
</script>
